function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#90959A",
  fillRule: "evenodd",
  d: "M3.526 8.292c-.186.002-.363.078-.493.21-.13.133-.201.312-.2.498 0 .39.31.708.693.708h7.824c.186-.002.363-.078.492-.21.13-.134.202-.312.2-.498.002-.186-.07-.364-.2-.497s-.306-.209-.492-.211H3.526z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#90959A",
  fillRule: "evenodd",
  d: "M4.414 6.383L2.339 8.477c-.137.14-.214.328-.214.523s.077.383.214.523l2.075 2.094c.068.069.149.123.238.16.09.037.185.056.281.056.097 0 .192-.019.281-.056.09-.037.17-.091.238-.16.138-.139.216-.327.216-.523s-.078-.384-.216-.524L3.896 9l1.556-1.57c.138-.14.215-.328.215-.523 0-.196-.077-.384-.215-.524-.068-.068-.149-.122-.238-.16-.089-.037-.184-.056-.28-.056-.097 0-.193.02-.282.056-.09.038-.17.092-.238.16zM8.5 2.625v1.417h4.959v9.916H8.5v1.417h4.963c.78 0 1.412-.633 1.412-1.413V4.038c0-.185-.036-.37-.107-.54-.07-.172-.175-.328-.306-.46-.131-.13-.287-.235-.458-.306-.172-.07-.355-.107-.541-.107H8.5z",
  clipRule: "evenodd"
});

var SvgSignOut = function SvgSignOut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "none",
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSignOut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign-out.34c92bdc.svg";
export { ForwardRef as ReactComponent };